import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const FIELDS = [
  { k: "discord_url", l: "DISCORD INVITE URL", ph: "https://discord.gg/injectd" },
  { k: "hero_tagline", l: "HOMEPAGE HERO TAGLINE", ph: "Premium cheats..." },
  { k: "announcement", l: "ANNOUNCEMENT BANNER (blank = hidden)", ph: "e.g. Summer sale — 20% off lifetime keys" },
  { k: "venmo_handle", l: "VENMO HANDLE (shown at manual checkout)", ph: "@your-venmo" },
  { k: "applepay_handle", l: "APPLE PAY NUMBER (shown at manual checkout)", ph: "843-822-3548" },
  { k: "notify_email", l: "PAYMENT ALERT EMAIL (get pinged when a buyer pays)", ph: "you@email.com (blank = admin login email)" },
  { k: "orders_boost", l: "KEYS DELIVERED DISPLAY BOOST (homepage stat, real sales stack on top)", ph: "0" },
  { k: "vouches_boost", l: "VOUCHES DISPLAY BOOST (homepage stat, real vouches stack on top)", ph: "0" },
  { k: "staff_discord_ids", l: "STAFF DISCORD IDS (comma-separated — powers STAFF ON DUTY on the homepage)", ph: "1234567890, 0987654321" },
];

export default function AdminSettings() {
  const [form, setForm] = useState({ discord_url: "", hero_tagline: "", announcement: "", venmo_handle: "", applepay_handle: "", notify_email: "", orders_boost: "0", vouches_boost: "0", staff_discord_ids: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => setForm({
      discord_url: r.data.discord_url || "",
      hero_tagline: r.data.hero_tagline || "",
      announcement: r.data.announcement || "",
      venmo_handle: r.data.venmo_handle || "",
      applepay_handle: r.data.applepay_handle || "",
      notify_email: r.data.notify_email || "",
      orders_boost: String(r.data.orders_boost ?? 0),
      vouches_boost: String(r.data.vouches_boost ?? 0),
      staff_discord_ids: r.data.staff_discord_ids || "",
    })).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", {
        ...form,
        orders_boost: Math.max(0, parseInt(form.orders_boost, 10) || 0),
        vouches_boost: Math.max(0, parseInt(form.vouches_boost, 10) || 0),
      });
      toast.success("Settings saved");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Save failed");
    }
    setSaving(false);
  };

  return (
    <div className="rounded-2xl border border-white/12 p-8 max-w-2xl space-y-5" data-testid="admin-settings">
      {FIELDS.map((f) => (
        <div key={f.k}>
          <label className="font-mono text-[10px] tracking-[0.2em] text-white/40">{f.l}</label>
          <input value={form[f.k]} placeholder={f.ph} onChange={(e) => setForm({ ...form, [f.k]: e.target.value })}
            data-testid={`settings-${f.k}`}
            className="mt-2 w-full bg-transparent border border-white/12 px-3 py-3 text-sm focus:border-white focus:outline-none" />
        </div>
      ))}
      <button onClick={save} disabled={saving} data-testid="save-settings-btn" className="btn-inj px-8 py-4 text-sm inline-flex items-center gap-2 disabled:opacity-60">
        {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} SAVE SETTINGS
      </button>
    </div>
  );
}
